import script from "./MascotMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MascotMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MascotMenu.vue?vue&type=style&index=0&id=6ad08db5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ad08db5"]])

export default __exports__